"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNextStepNavigation = useNextStepNavigation;
var _contexts = require("../contexts");
function useNextStepNavigation() {
  const {
    wasNavigationToNextStep
  } = (0, _contexts.useNextStepNavigationContext)();
  const setWasNavigationToNextStep = value => {
    if (wasNavigationToNextStep) {
      wasNavigationToNextStep.current = value;
    }
  };
  return {
    setWasNavigationToNextStep,
    wasNavigationToNextStep: wasNavigationToNextStep?.current ?? false
  };
}